'use client'
import React from 'react'

export const ManagerContext = React.createContext(null)
